import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import i18n from '../../../../../i18n/i18n';
import {DrillDownLevelName} from '../../../../../types/api/drillDown';
import {LevelConfiguration} from '../types';

const DEFAULT_LEVEL_ORDER: DrillDownLevelName[] = [
  'make',
  'model_family_group',
  'model',
  'year',
  'power',
  'fuel_type',
  'transmission',
  'drive',
  'car_style',
  'mileage_range',
];

export function getLevelConfigurations(
  hiddenLevels: DrillDownLevelName[] | Nullish,
  levelOrder: DrillDownLevelName[] = DEFAULT_LEVEL_ORDER
): LevelConfiguration[] {
  return levelOrder
    .map((levelName) => {
      const key = match(levelName)
        .with('make', () => 'make')
        .with('model_family_group', () => 'modelFamily')
        .with('model', () => 'model')
        .with('year', () => 'year')
        .with('power', () => 'power')
        .with('fuel_type', () => 'fuel')
        .with('transmission', () => 'transmission')
        .with('drive', () => 'drive')
        .with('car_style', () => 'bodyStyle')
        .with('mileage_range', () => 'mileage')
        .exhaustive();

      return {
        name: levelName,
        translationKey: `entity.drillDown.labels.${key}`,
        formatter:
          levelName === 'power'
            ? (value: string | Nullish) =>
                isNotNil(value) ? `${value} ${i18n.t('general.metric.kW')}` : ''
            : undefined,
      };
    })
    .filter((levelConfiguration) => !hiddenLevels?.includes(levelConfiguration.name))
    .map((levelConfiguration) => ({
      ...levelConfiguration,
      title: i18n.t(levelConfiguration.translationKey),
    }));
}
